<template>
<!-- 
    头像上传
 -->
    <div>
        <a-upload
            accept="image/png, image/jpeg, image/jpg"
            :file-list="fileList"
            :show-upload-list="false"
            :customRequest="customRequest"
            :max-count="1"
        >
            <div :class="['upload_btn dis_ajc', props.radius&&'radius']">
                <template v-if="fileList.length">
                    <!-- <img class="user_avatar" :src="fileList[0].url" alt=""> -->
                    <div class="user_avatar_div" :style="{ 'background-image': 'url('+fileList[0].url+')' }" alt=""></div>
                </template>
                <template v-else>
                    <div class="t1"><plus-outlined /></div>
                    <div class="t1">上传</div>
                </template>
            </div>
        </a-upload>
    </div>
</template>

<script setup>
import { ref, watch } from "vue"; 
import { PlusOutlined } from "@ant-design/icons-vue";
import { sdkOssUpimage } from "@/api/common.js"; 
import { message, Form } from 'ant-design-vue';
import { generateUUID } from "@/utils/function"; 
const props = defineProps({
    fileUrl: {
        type: String,
    },
    radius: {
        type: Boolean
    }
})
const emit = defineEmits([ "update:fileUrl" ])

const formItemContext = Form.useInjectFormItemContext();

// 图片上传 
const fileList = ref([]); 
watch(() => props.fileUrl, newVal => {
    // console.log("newVal==", newVal);
    if (newVal) {
        fileList.value = [{
            id: 1, 
            url: newVal, 
        }]; 
        fileChange(); 
    }
}, { immediate: true })

// 上传图片 
async function customRequest(params) { 
    console.log("===", params);
    let fileData = params.file; 
    let fileType = params.file.type; 
    let fileSize = params.file.size; 

    // 判断文件类型 
    let fileTypeList = [ "image/png", "image/jpeg", "image/jpg" ];
    if (!fileTypeList.includes(fileType)) { 
        message.error('仅支持上传png、jpeg、jpg格式的图片');
        return 
    }
    // 判断文件大小 5M 
    if ((fileSize/1024/1024)>5) { 
        message.error('上传头像图片大小不能超过 5MB!');
        return 
    }

    // let index = fileData.name.lastIndexOf(".");
    // let name = fileData.name.substring(0, index); 
    // let randomNum = new Date().getTime() + Math.floor(Math.random() * (1000 + 1)); 
    // let suffix = fileData.name.substring(index); 
    // let fileName = name + "_" + randomNum + suffix; 

    let index = fileData.name.lastIndexOf(".");
    let suffix = fileData.name.substring(index); 
    let uuid = generateUUID(); 
    let fileName = uuid + suffix; 

    let client = await sdkOssUpimage(); 
    client.put(client.options.env + "/" + fileName, fileData).then((result) => { 
        console.log("==上传成功==", result, fileName); 
        fileList.value = [{ 
            id: 1,
            // name: fileData.name, 
            name: fileName, 
            url: result.url, 
        }]; 
        
        fileChange(); 
        // registerForm.value.validateFields(['studentImage']);
    }); 
} 

// 变化事件 
function fileChange() {
    emit("update:fileUrl", fileList.value[0]?.url)
    formItemContext.onFieldChange(); 
}



</script>

<style lang="scss" scoped>
@import "@/style/var.scss";
.upload_btn {
    width: 100px;
    height: 100px; 
    color: #999999;
    border: 1px dashed #C9C9C9;
    border-radius: 4px;
    flex-direction: column;
    cursor: pointer;
    overflow: hidden;
    &:hover {
        color: $primary-color;
        border-color: $primary-color;
    }
    .user_avatar {
        width: 100%;
        height: auto;
    }
    .user_avatar_div {
        width: 100%;
        height: 100%;

        // background-image: url('background.jpg'); /* 替换为你的图片路径 */
        background-position: center center; /* 水平垂直居中 */
        background-repeat: no-repeat; /* 不重复背景图 */
        background-size: cover;
    }
}
.radius {
    border-radius: 50%;
}
.upload_tip_box {
    flex: 1;
    padding: 20px;
    line-height: 1.3;
    color: #999999;
}

</style>